import $ from "jquery";
import "bootstrap/js/src/util";
import * as log from "loglevel";

log.setLevel(process.env.NODE_ENV === "production" ? log.levels.WARN : log.levels.TRACE);

window.$ = window.jQuery = $;